import { useState } from "react";
import { dispatch } from "../../state/store";
import { setDeviceChangeHistoryRefresh } from "../../state/ducks";

import { deviceChangeHistoryService } from "../../services";
import { responseUtil } from "../../utils";

export const useCreateDeviceChangeHistoryRecord = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const mutationCallback = async (dusns, action) => {
    setLoading(true);
    setError(false);

    try {
      const res = await deviceChangeHistoryService.createChangeHistoryRecord(dusns, action);

      if (responseUtil.isResponseSuccessful(res)) {
        dispatch(setDeviceChangeHistoryRefresh(true));
      }
    } catch (err) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return { mutationCallback, loading, error };
};
